module.exports = __webpack_public_path__ + "static/veneer1-cdcb92dcf63718b891a9a694e5b445c9.jpg";